import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { AppVariablesProviderComponent } from './app-variables-provider.component';
import { ApiClientModule } from '@tablesready/api-client';

@NgModule({
  imports: [CommonModule, ApiClientModule, RouterModule],
  declarations: [AppVariablesProviderComponent],
  exports: [AppVariablesProviderComponent],
})
export class AppVariablesModule {}
